
// verifyCondition_herderChat: Esta función verifica si se cumple la condición para que se 
// renderice el componente.
export const verifyCondition_herderChat = ( socketConnected, chatName ) => {
    let condition = (chatName && socketConnected);
    return condition;
}
